import actions from '../../actionTypes';

export default (siteId) => {
  return {
    type: actions.GET_FILTERS,
    siteId,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/getFilters.js